import { render, staticRenderFns } from "./brand-image.vue?vue&type=template&id=6741ecd0&"
import script from "./brand-image.vue?vue&type=script&lang=js&"
export * from "./brand-image.vue?vue&type=script&lang=js&"
import style0 from "./brand-image.vue?vue&type=style&index=0&id=6741ecd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports